module.exports = __webpack_public_path__ + "media/images/test/example-5878c293ce6dfe3a5aeb7de5f8e015fd.svg";